import { generateDeviceId } from '@1debit/device-intelligence';

import { AnalyticsBase } from './AnalyticsBase';
import { type EventRouterHandlerConfig } from './EventRouterHandler';
import { type SegmentHandlerConfig } from './SegmentHandler';
import { getDeviceIntelligenceEnvironment } from './utils/deviceIntelligenceHelpers';

type DefaultConfig = EventRouterHandlerConfig & SegmentHandlerConfig;

type AnalyticsConfigNoDeviceId =
	| ({ variant: 'default' } & Omit<DefaultConfig, 'deviceId'>)
	| ({ variant: 'onlyEventRouter' } & Omit<EventRouterHandlerConfig, 'deviceId'>);

export class AnalyticsWithDeviceId extends AnalyticsBase {
	constructor(config: AnalyticsConfigNoDeviceId) {
		const deviceIntelligenceEnvironment = getDeviceIntelligenceEnvironment(config.env);
		const deviceId = generateDeviceId({
			env: deviceIntelligenceEnvironment,
		});

		super({ ...config, deviceId });
	}
}
